import React, { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ConfigProvider, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { Locale } from 'antd/es/locale-provider';
import plPL from 'antd/es/locale/pl_PL';
import enGB from 'antd/es/locale/en_GB';
import './App.less';
import Routes from './Routes';
import MaintenanceGate from './components/MaintenanceGate/MaintenanceGate';
import useActivityQueue from './hooks/useActivityQueue';
import { getLanguage, Language } from './i18n';

// Wbudowane napisy antd (np. „OK” i „Anuluj” w potwierdzeniach, „Brak danych”) w języku interfejsu
const ANTD_LOCALES: Record<Language, Locale> = {
  pl: plPL,
  en: enGB,
};

function App() {
  const { pathname } = useLocation();
  // Odświeża App po zmianie języka — antd dostaje wtedy nowe napisy
  useTranslation();

  // Niewysłane próby z monitoringu aktywności idą zaraz po zalogowaniu ucznia
  useActivityQueue();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <ConfigProvider locale={ANTD_LOCALES[getLanguage()]}>
      <Suspense fallback={<Spin spinning />}>
        <div className="App">
          {/* Obejmuje też trasy publiczne — przy przerwie technicznej nie działa nic. */}
          <MaintenanceGate>
            <Routes />
          </MaintenanceGate>
        </div>
      </Suspense>
    </ConfigProvider>
  );
}

export default App;
